import { XIcon } from "lucide-react"

import type { UploadEntry } from "@/components/documents/reducers/uploadQueueReducer"
import { Progress } from "@/components/ui/progress"

interface Props {
  queue: UploadEntry[]
  onDismiss: (uuid: string) => void
}

export function UploadProgressBar({ queue, onDismiss }: Props) {
  return (
    <div className="bg-background flex w-full flex-col items-center gap-2 rounded-lg p-5">
      {queue.map((entry) => (
        <div
          key={entry.uuid}
          className="flex w-full flex-col gap-2 text-sm lg:w-auto lg:flex-row lg:items-center lg:gap-5"
        >
          <span className="max-w-full truncate lg:max-w-none">
            {entry.file.name}
          </span>

          {entry.error ? (
            <div className="text-error flex w-full flex-row items-center justify-between gap-3 lg:w-auto lg:justify-start lg:gap-5">
              <span className="min-w-0 flex-1 break-words">{entry.error}</span>
              <button
                onClick={() => onDismiss(entry.uuid)}
                className="cursor-pointer"
              >
                <XIcon className="text-destructive h-4 w-4" />
              </button>
            </div>
          ) : (
            <div className="flex w-full flex-col gap-2 lg:w-auto lg:flex-row lg:items-center">
              <Progress value={entry.progress} className="w-full lg:w-sm" />
              <span className="whitespace-nowrap">
                {entry.progress}% / 100%
              </span>
            </div>
          )}
        </div>
      ))}
    </div>
  )
}
